import React from 'react';
import {useGlobalFeaturesQuery} from '../../generated/graphql';

const spacedToCamel = (str: string) =>
  str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase(),
    )
    .replace(/\s+/g, '');

type GlobalFeatureObject = [
  {
    [feature: string]: object;
  },
  boolean,
];

export const useGlobalFeatures = (): GlobalFeatureObject => {
  const {data, loading} = useGlobalFeaturesQuery({
    fetchPolicy: 'cache-and-network',
  });

  const features = React.useMemo(() => {
    if (!data?.globalFeatures) return {};
    return data.globalFeatures.reduce(
      (obj, feature) =>
        feature && feature.name
          ? Object.assign(obj, {[spacedToCamel(feature.name)]: {}})
          : obj,
      {},
    );
  }, [data]);
  return [features, loading && !data?.globalFeatures];
};
